'use client';

/**
 * @fileoverview Tiny client-only mount that registers the global ⌘K / `/`
 * keyboard shortcut on the consumer surface (FRE-825).
 *
 * `AppShellLayout` is an RSC by default — wrapping the entire shell in
 * `'use client'` would bleed the consumer surface across the RSC/Client
 * boundary unnecessarily. Instead, this 4-line sibling renders nothing and
 * lives purely to mount `useGlobalSearchShortcut` from inside the shell.
 *
 * The marketing / apex surfaces mount the same hook from `SiteHeader`. Both
 * mounts converge on the same `useSearchSheet` module-scoped store, so a
 * page that renders both surfaces (e.g. unauth pages on the app host) is
 * still idempotent — `setOpen(true)` against an already-open sheet is a
 * no-op.
 *
 * @since FRE-825
 */

import { useGlobalSearchShortcut } from '@/hooks/useGlobalSearchShortcut';

export function GlobalSearchShortcutMount(): null {
  useGlobalSearchShortcut();
  return null;
}
